import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { Row, Container, Col, Button, Tabs, Tab } from "react-bootstrap";
import { Box, AddressBox, DefaultAddressText, FixedFooter } from "./styles";
import {
  deleteAddress,
  addAddress,
  editAddresses,
  getAddress,
  getAddresses,
} from "../../components/AddressComponent/services/addressService";
import notify from "../../components/UI/toast";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import AddressComponent from "../../components/AddressComponent";
import ModalApp from "../../components/ModalApp";
import FixedAddressModal from "../../components/AddressComponent/FixedAddressModal";
import ErrorBoundary from "../../components/ErrorBoundary";
import LockIcon from "../../assets/padlock.svg";

import { useSelector, useDispatch } from "react-redux";
import { getCart, setPaymentMethod } from "../../Redux/cartSlice";
import { swalCustom } from "../../utils/functions";
import useLocalStorage from "hooks/useLocalStorage";
import { useApp } from "../../contexts/AppContext";
import { trackClick, trackCheckoutAddressEvent } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";

export default function ListAddressesPage() {
  const navigate = useNavigate();
  const { whitelabel } = useApp();

  const [address, setAddress] = useState({});
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("dinheiro");
  const {
    user,
    changeAddress,
    addressesData,
    addressShipping,
    setUpdateAddresses,
    mainAddress,
    setMainAddress,
  } = useUserData();

  const [showPaymentWarning, setShowPaymentWarning] = useState(false);
  const [showFixedModal, setShowFixedModal] = useState(false);
  const dispatch = useDispatch();
  const { cart, loading } = useSelector((state) => state.cartSlice);

  // Sincronizar mainAddress com o endereço já selecionado (addressShipping)
  // para que o radio button fique marcado ao entrar na tela
  useEffect(() => {
    if (!mainAddress && addressShipping && addressShipping.uuid) {
      setMainAddress(addressShipping);
    }
  }, [addressShipping]);

  const isSafraAddress = (addr) => addr?.fixed === 1;

  const safraAddressMessage =
    "Este é seu endereço de cadastro no Safra. Para alterá-lo é necessário entrar em contato com o banco.";

  function deletarEndereco(addressInfo) {
    if (isSafraAddress(addressInfo)) {
      notify(safraAddressMessage, "info");
      return;
    }
    trackCheckoutAddressEvent({ title: "excluir" });

    const addressUuid = addressInfo?.uuid;
    if (!addressUuid) return;
    swalCustom
      .fire({
        html: '<p class="fw-light fs-5 mb-0">Deseja excluir este endereço?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "info",
        iconColor: "rgba(0, 38, 217, 1)",
      })
      .then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          var message = "";
          var type = "success";
          deleteAddress(addressUuid)
            .then((response) => {
              message = response.message;
            })
            .catch((error) => {
              message = error.message;
              type = "error";
            })
            .finally(() => {
              notify(message, type);
              setUpdateAddresses(new Date());
              refreshResume();
            });
        }
      });
  }

  async function saveAndSelectAddress(address) {
    let result = null;

    if (address.uuid) {
      result = await editAddresses(address);
    } else {
      result = await addAddress(address);
    }

    if (!result.status) {
      notify(result.data.message, "error");
      return false;
    }

    const savedUuid = result.data?.data?.uuid || address.uuid;
    const updatedAddress = {
      ...address,
      uuid: savedUuid,
      zipCode: address.zipCode || address.cep,
    };
    setMainAddress(updatedAddress);

    if (address.uuid) {
      changeAddress(updatedAddress);
    }

    notify(result.data.message, "success");
    setUpdateAddresses(new Date());
    refreshResume();
    return true;
  }

  async function handleEndereco(address) {
    address["customerUuid"] = user.uuid;

    if (address.main === true || address.main === 1) {
      try {
        const addresses = await getAddresses();

        const currentMain = addresses.find(
          (addr) => addr.main === true || addr.main === 1,
        );

        if (currentMain && currentMain.uuid !== address.uuid) {
          const updateMainResult = await editAddresses({
            ...currentMain,
            uuid: currentMain.uuid,
            customerUuid: user.uuid,
            main: "0",
          });

          if (!updateMainResult.status) {
            notify("Erro ao remover o endereço principal anterior", "error");
            return;
          }
        }

        await saveAndSelectAddress(address);
      } catch (error) {
        console.error("Erro ao atualizar endereço principal:", error);
        notify("Erro ao atualizar endereço", "error");
      }
      return;
    }

    await saveAndSelectAddress(address);
  }

  function editarEndereco(selectedAddress) {
    if (isSafraAddress(selectedAddress)) {
      notify(safraAddressMessage, "info");
      return;
    }
    trackCheckoutAddressEvent({ title: "editar" });
    setAddress(selectedAddress);
    setOpen(true);
  }

  function adicionarEndereco() {
    trackCheckoutAddressEvent({ title: "adicionar-novo-endereco" });
    setAddress({});
    setOpen(true);
  }

  const handleAddressSelect = (address, position) => {
    scrollTo({top: 0});
    trackCheckoutAddressEvent({ title: `selecionou-endereco-${position}` });
    setMainAddress(address);
  };

  const handleSelectClick = () => {
    trackCheckoutAddressEvent({ title: "selecionar" });
    handleSelectMainAddress();
  };

  function refreshResume() {
    setOpen(false);
  }

  const handleCheckout = () => {
    // if (cart.warning) {
    //   return;
    // }
    if (disable()) {
      return;
    }

    if (!Object.keys(addressShipping).length) {
      notify("Selecione o endereço de entrega!", "error");
      return;
    }
    navigate("/loja/orderresumepag/");
  };

  const triggerWarning = (reason) => {
    notify(reason, "error");
  };
  const handleAddress = (uuid) => {
    //dispatch(setLoading({value: true}))
    let address_selected = addressesData.find((a) => a.uuid === uuid);
    if (address_selected) {
      changeAddress(address_selected);
      refreshResume();
    }
  };

  const handleDefaultChecked = (address, index) => {
    //return true;
    // !Object.keys(addressShipping).length
    //   ? index === 0 && true
    //   : addressShipping.uuid === address.uuid && true;

    if (Object.keys(addressShipping).length === 0) {
      return index === 0;
    } else {
      return addressShipping.uuid === address.uuid;
    }
  };

  // useEffect(() => {
  //     const cpf = user.cpf
  //     const cep = addressShipping.cep
  //     if(cpf && cep)
  //         dispatch(getCart({cpf, cep}))
  //         .unwrap()
  //         .then((payload) => {
  //             if(payload.warning) {
  //                 for (const val of payload.warning) {
  //                     triggerWarning(reasons[val.reason])
  //                     break;
  //                 }
  //             }
  //         })
  //   }, [user,addressShipping])

  const handlePaymentMethod = (type) => {
    const textType = type ? "dinheiro" : "pontos";

    dispatch(setPaymentMethod({ value: textType }));
    setTab(textType);

    if (textType === "pontos" && cart.minimum_payments.WL > user.balance) {
      setShowPaymentWarning(true); // Mostra o aviso se não houver pontos suficientes
      return;
    } else {
      setShowPaymentWarning(false); // Esconde o aviso se houver pontos suficientes
    }
  };

  const disable = () => {
    if (
      cart?.minimum_payments &&
      cart?.minimum_payments?.WL &&
      tab === "pontos"
    ) {
      if (cart.minimum_payments.WL > user.balance) {
        return true;
      }
    }
    return false;
  };

  if (loading) return <LoaderSmall />;

  if (!addressesData.length) {
    window.location.assign("/loja");
  }

  function handleSelectMainAddress() {
    if (!mainAddress || !mainAddress.uuid) {
      notify("Selecione um endereço antes de continuar!", "error");
      return;
    }

    const mappedAddress = {
      ...mainAddress,
      address_line1: mainAddress.streetName,
      address_line2: mainAddress.neighborhood,
      address_line3: mainAddress.complement,
      cep: mainAddress.zipCode,
    };

    changeAddress(mappedAddress);
    navigate("/loja/ordersummary");
  }

  return (
    <>
      <ModalApp
        show={open}
        handleModal={() => setOpen(false)}
        contentClassName="modal-address"
      >
        <AddressComponent
          onConfirm={handleEndereco}
          onCancel={() => setOpen(false)}
          address={address}
        />
      </ModalApp>
      <FixedAddressModal
        show={showFixedModal}
        onClose={() => setShowFixedModal(false)}
      />
      <ErrorBoundary>
        <div className="wl-page mt-4" style={{ paddingBottom: "140px" }}>
          <Box className="pb-3">
            <Row className="m-3 mt-0">
              <DefaultAddressText className="font-wl-500 text-mg">
                Meus endereços
              </DefaultAddressText>
              <Col className="gy-0">
                {addressesData ? (
                  [...addressesData]
                    .sort((a, b) => {
                      // 1) Endereço selecionado sempre primeiro
                      const aSelected = mainAddress && a.uuid === mainAddress.uuid ? 1 : 0;
                      const bSelected = mainAddress && b.uuid === mainAddress.uuid ? 1 : 0;
                      if (bSelected !== aSelected) return bSelected - aSelected;

                      // 2) Endereço principal como segundo critério
                      const aMain = a.main === true || a.main === 1 ? 1 : 0;
                      const bMain = b.main === true || b.main === 1 ? 1 : 0;
                      return bMain - aMain;
                    })
                    .map(
                    (address, index) => (
                        <AddressBox
                          key={address.uuid}
                          main={
                            mainAddress && address.uuid === mainAddress.uuid
                          }
                        >
                          {isSafraAddress(address) && (
                            <div
                              style={{
                                position: "absolute",
                                top: 16,
                                right: 16,
                                cursor: "pointer",
                              }}
                              onClick={() => setShowFixedModal(true)}
                            >
                              <img src={LockIcon} alt="Endereço fixo" width={16} height={18} />
                            </div>
                          )}
                          <Row>
                            <Col className="col-1 p-4 d-flex align-items-center justify-content-center">
                              <input
                                type="radio"
                                name="selectMainAddress"
                                className="selectMainAddressRadio"
                                checked={
                                  mainAddress &&
                                  address.uuid === mainAddress.uuid
                                }
                                onChange={() => handleAddressSelect(address, index + 1)}
                              />
                            </Col>
                            <Col>
                              <p className="mt-2 mb-1 color-wl font-wl-600">
                                {address.label}
                              </p>

                              <div>
                                <p className="mb-0 color-wl text-sm">
                                  {address.streetName}, {address.number}{" "}
                                </p>
                                <p className="mb-0 color-wl text-sm">
                                  {address.complement && `${address.complement} - `}
                                  {address.neighborhood}{" "}
                                </p>
                                <p className="mb-0 color-wl text-sm">
                                  {`${address.zipCode} - ${address.city} - ${address.state}`}
                                </p>
                              </div>
                              {isSafraAddress(address) && (
                                <div className="mt-3">
                                  <p className="text-xs mb-1 text-text_primary_color italic">
                                    {safraAddressMessage}
                                  </p>
                                </div>
                              )}
                              <div className="my-2 d-flex align-items-center justify-content-start">
                                <div className="d-flex align-items-center gap-3 font-wl-700">
                                  {(address.main === true || address.main === 1) && (
                                    <span className="address-principal-badge">
                                      Principal
                                    </span>
                                  )}
                                  {!isSafraAddress(address) && (
                                    <>
                                      <a
                                        className="confirm text-xs"
                                        style={{
                                          color: whitelabel?.theme?.text_primary_color,
                                        }}
                                        onClick={() => {
                                          editarEndereco(address);
                                        }}
                                      >
                                        Alterar
                                      </a>
                                      <a
                                        className="link-cancel-wl text-xs"
                                        style={{ color: "#96143C" }}
                                        onClick={() => {
                                          deletarEndereco(address);
                                        }}
                                      >
                                        Remover
                                      </a>
                                    </>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </AddressBox>
                      ),
                  )
                ) : (
                  <div>
                    <p className="mb-0 text-sm ">
                      {" "}
                      Cadastre o endereço que deseja receber seu <br /> pedido
                      para seguir com a compra.{" "}
                    </p>
                    <div className="mt-4">
                      <a
                        className="link-default-wl"
                        onClick={() => adicionarEndereco()}
                        style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: 700 }}
                      >
                        Adicionar Endereço
                      </a>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Box>
          <FixedFooter>
            <Button
              type="button"
              className={`btn-default-wl ${
                !addressesData.length || (disable() && "disable")
              }`}
              style={{ fontSize: "12px" }}
              onClick={handleSelectClick}
            >
              Usar este endereço
            </Button>
            <Button
              type="button"
              className={`btn-outline-wl`}
              style={{ fontSize: "12px" }}
              onClick={() => {
                trackClick({
                  title: "adicionar-endereco",
                  contentType: "checkout",
                  screenName: "carrinho",
                  tagId: tagIdFromLegacySuffix("16"),
                });
                adicionarEndereco();
              }}
            >
              Adicionar endereço
            </Button>
          </FixedFooter>
        </div>
      </ErrorBoundary>
    </>
  );
}
